var _path, _path2, _path3, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHelp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 29.333c7.364 0 13.333-5.97 13.333-13.333 0-7.364-5.97-13.333-13.333-13.333C8.636 2.667 2.667 8.637 2.667 16c0 7.364 5.97 13.333 13.333 13.333z",
    stroke: "url(#help_svg__mobile-paint0_linear)",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.013 18.667V18c.04-1 1.32-1.387 2.707-3.066.493-.614.867-1.054 1.093-1.8.387-1.2.08-2.227 0-2.44a3.837 3.837 0 00-1.52-2.08A3.705 3.705 0 0016.187 8c-.32 0-1.04 0-1.814.4-.666.347-1.066.8-1.266 1.067-.787.96-1.027 2.04-1.107 2.613",
    stroke: "url(#help_svg__mobile-paint1_linear)",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.987 24h.027",
    stroke: "url(#help_svg__mobile-paint2_linear)",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "help_svg__mobile-paint0_linear",
    x1: 2.667,
    y1: 29.333,
    x2: 34.699,
    y2: 18.434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D9CAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#779AF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "help_svg__mobile-paint1_linear",
    x1: 12,
    y1: 18.667,
    x2: 22.071,
    y2: 16.095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D9CAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#779AF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "help_svg__mobile-paint2_linear",
    x1: 15.987,
    y1: 25,
    x2: 16.023,
    y2: 25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D9CAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#779AF7"
  })))));
}

export default SvgHelp;